
import { ACA_CAMPAIGN_CONFIG } from './config/aca.config'
import type { CampaignRegistry } from '../campaignRegistry.types'
import { ACA_CAMPAIGN_TYPE, ACA_CAMPAIGN_NAME } from './constants'
import ClientValidationStep from './steps/ClientValidationStep'
import EnrollmentDataStep from './steps/EnrollmentDataStep'
import EmploymentPlanStep from './steps/EmploymentPlanStep'
import AgentConsentsStep from './steps/AgentConsentsStep'
import ComplianceStep from './steps/ComplianceStep'
import FollowUpStep from './steps/FollowUpStep'

// New 6-step condensed flow components
export const acaComponents = {
    'client-validation': ClientValidationStep,
    'enrollment-data': EnrollmentDataStep,
    'employment-plan': EmploymentPlanStep,
    'agent-consents': AgentConsentsStep,
    'compliance': ComplianceStep,
    'follow-up': FollowUpStep,
}

const identifiers = [
    ACA_CAMPAIGN_TYPE,
    ACA_CAMPAIGN_NAME,
    ...(ACA_CAMPAIGN_CONFIG?.campaignNames || []),
]

export const acaRegistry: CampaignRegistry = {
    type: ACA_CAMPAIGN_TYPE,
    identifiers,
    stages: [],
    components: acaComponents
}
